import script from "./ProtocoloStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProtocoloStep.vue?vue&type=script&setup=true&lang=js"

import "./ProtocoloStep.vue?vue&type=style&index=0&id=7114e15d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7114e15d"]])

export default __exports__